import { Common } from "../Components/Canvas";
import Utility from "../js/utility";
import Bucket from "../js/bucket";

export default class Draw {
  constructor() {
    this.draw_glitter = Draw.draw_glitter.bind(this);
  }

  static history;
  static doDraw;
  static glitter_image = new Image();

  static draw = (ev) => {
    if (!Common.mobile && ev.buttons !== 1) return;

    let canvas = Common.main_canvas;

    // if bucket is selected then draw with it;
    if (Common.tool === "bucket") {
      new Bucket(Common.main_ctx, Common.color);
      return;
    }

    Utility.hideMenus();

    let ctx = Common.main_ctx;
    let history_ctx = Common.history_ctx;
    let pos = Common.mouse_position;

    ctx.lineWidth = history_ctx.lineWidth = Common.width;
    ctx.lineCap = history_ctx.lineCap = "round";
    ctx.strokeStyle = history_ctx.strokeStyle = Common.color;

    mousemove(ev);

    canvas.addEventListener(Common.pointermove, mousemove);
    canvas.addEventListener(Common.pointerup, pointerup);

    function mousemove(ev) {
      ctx.beginPath(); // begin
      history_ctx.beginPath(); // begin

      ctx.moveTo(pos.x, pos.y); // from
      history_ctx.moveTo(pos.x, pos.y); // from
      Utility.setPosition(ev);
      ctx.lineTo(pos.x, pos.y); // to
      history_ctx.lineTo(pos.x, pos.y); // to

      ctx.stroke(); // draw it!
      history_ctx.stroke(); // draw it!
    }
    function pointerup() {
      Utility.revealMenus();
      Draw.history.addToHistoryTest();
      // Draw.history.redrawHistory();

      canvas.removeEventListener(Common.pointermove, mousemove);
      canvas.removeEventListener(Common.pointerup, pointerup);
    }
  };

  static draw_glitter = (ev) => {
    Utility.hideMenus();

    let canvas = Common.main_canvas;
    let ctx = Common.main_ctx;
    let history_ctx = Common.history_ctx;
    let pos = Common.mouse_position;

    ctx.lineWidth = history_ctx.lineWidth = Common.width;
    ctx.lineCap = history_ctx.lineCap = "round";
    ctx.strokeStyle = history_ctx.strokeStyle = Common.color;

    let patternImage = Draw.glitter_image;
    let pattern = ctx.createPattern(patternImage, "repeat");
    let pattern_history = history_ctx.createPattern(patternImage, "repeat");

    mousemove(ev);

    function mousemove(ev) {
      ctx.beginPath(); // begin
      history_ctx.beginPath(); // begin
      ctx.strokeStyle = pattern;
      history_ctx.strokeStyle = pattern_history;

      ctx.moveTo(pos.x, pos.y); // from
      history_ctx.moveTo(pos.x, pos.y); // from
      Utility.setPosition(ev);
      ctx.lineTo(pos.x, pos.y); // to
      history_ctx.lineTo(pos.x, pos.y); // to

      ctx.stroke(); // draw it!
      history_ctx.stroke(); // draw it!
    }
    function pointerup() {
      Utility.revealMenus();
      Draw.history.addToHistoryTest();

      canvas.removeEventListener(Common.pointermove, mousemove);
      canvas.removeEventListener(Common.pointerup, pointerup);
    }

    canvas.addEventListener(Common.pointermove, mousemove);
    canvas.addEventListener(Common.pointerup, pointerup);
  };

  static draw_image = () => {
    Utility.revealMenusInstant();

    // let dpr = window.devicePixelRatio;
    // Common.main_canvas.width = Common.canvas_width * dpr;
    // Common.main_canvas.height = Common.canvas_height * dpr;
    // console.log(Common.canvas_width);

    let ctx = Common.main_ctx;
    let history_ctx = Common.history_ctx;
    let chosenImgContainer = document.querySelector(".chosenImageContainer");
    let rect = document.querySelector(".rect");
    let choose_image_buttons = document.querySelector(".chooseImageButtons");

    chosenImgContainer.classList.remove("showImageContainer");
    // reset buttons position after choosing;
    choose_image_buttons.style.left = "";
    choose_image_buttons.style.top = "";

    rect.appendChild(Common.newImage);

    console.log(rect.clientHeight);

    Common.newImage.style.width = "100%";
    Common.newImage.style.height = "100%";
    Common.newImage.style.objectFit = "contain";

    let { image_width, image_height } = Utility.getContainedSize(
      Common.newImage
    );
    console.log(image_width, image_height);

    ctx.beginPath();
    ctx.save();
    history_ctx.beginPath();
    history_ctx.save();

    let left = rect.offsetLeft + rect.clientWidth / 2 - image_width / 2 + 1;
    let top = rect.offsetTop + rect.clientHeight / 2 - image_height / 2 + 1;

    ctx.translate(left + image_width / 2, top + image_height / 2);
    ctx.rotate((Math.PI / 180) * Common.rotationAngle);
    history_ctx.translate(left + image_width / 2, top + image_height / 2);
    history_ctx.rotate((Math.PI / 180) * Common.rotationAngle);

    ctx.drawImage(
      Common.newImage,
      -image_width / 2,
      -image_height / 2 + 0.5,
      image_width, // * dpr
      image_height // * dpr
    );
    ctx.restore();
    history_ctx.drawImage(
      Common.newImage,
      -image_width / 2,
      -image_height / 2 + 0.5,
      image_width,
      image_height
    );
    history_ctx.restore();

    Common.newImage.remove();

    Draw.history.addToHistoryTest();
    // console.log(Common.canvas_width);
    // Common.main_canvas.style.width = Common.canvas_width + "px";
    // Common.main_canvas.style.height = Common.canvas_height + "px";
  };

  static draw_background = (image_src) => {
    let bgImage = new Image();

    bgImage.setAttribute("crossOrigin", "");
    bgImage.src = image_src + "?" + new Date().getTime();

    bgImage.onload = function () {
      Common.history_ctx.drawImage(
        bgImage,
        0,
        0,
        Common.canvas_width,
        Common.canvas_height
      );

      Draw.history.backgrounds.push(Common.history_canvas.toDataURL());
      Draw.history.historyTest[1] = Common.history_canvas.toDataURL();
      Draw.history.addBgToHistory();
      // Draw.history.redrawHistory();
      Common.history_ctx.clearRect(
        0,
        0,
        Common.canvas_width,
        Common.canvas_height
      );
    };

    // let bgImage = new Image();
    // let bg_canvas = document.createElement("canvas");
    // let bg_ctx = bg_canvas.getContext("2d");
    // bg_canvas.width = Common.canvas_width;
    // bg_canvas.height = Common.canvas_height;

    // bgImage.src = image_src + "?" + new Date().getTime();
    // bgImage.setAttribute("crossOrigin", "");

    // bgImage.onload = function () {
    //   Common.background_ID++;

    //   bg_ctx.drawImage(
    //     bgImage,
    //     0,
    //     0,
    //     Common.canvas_width,
    //     Common.canvas_height
    //   );

    //   let background = bg_canvas.toDataURL();

    //   Draw.history.backgrounds.push(background);
    //   Draw.history.history.push(Common.background_ID);
    //   // first insertion of background;
    //   if (!Common.background_ID) {
    //     Draw.history.history.splice(1, 0, background);
    //   } else {
    //     Draw.history.history[1] = background;
    //   }

    // };
  };
}
